import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=4466d7ca&scoped=true&"
import script from "./Brackets.vue?vue&type=script&lang=js&"
export * from "./Brackets.vue?vue&type=script&lang=js&"
import style0 from "./Brackets.vue?vue&type=style&index=0&id=4466d7ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466d7ca",
  null
  
)

export default component.exports